import { c as _c } from "react/compiler-runtime";
import type { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function ProfileProxyCreditSpent(t0) {
  const $ = _c(5);
  const {
    profileProxyAction
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-font-normal tw-text-iron-500">Spent:</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = profileProxyAction.credit_spent ?? 0;
  let t3;
  if ($[1] !== t2) {
    t3 = formatNumberWithCommas(t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="tw-flex tw-items-center lg:tw-justify-center"><p className="tw-mb-0 tw-flex tw-items-center tw-gap-x-1.5 tw-text-md tw-font-normal tw-text-iron-500">{t1}<span className="tw-font-medium tw-text-iron-300">{t3}</span></p></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}